import React from "react";
import { useInvoiceDetailStore } from "../../store";
import { Project } from "./Project";

export const BudgetItemsCard = () => {
  const store = useInvoiceDetailStore();

  return (
    <React.Fragment>
      {store.invoice?.projects.map((project) => (
        <Project key={project.id} project={project} />
      ))}
    </React.Fragment>
  );
};
